import { Topic } from 'widgets/myPortfolioCapsules/topics/Topic';
import { TopicType } from 'widgets/myPortfolioCapsules/topics/TopicType';
import React from 'react';
import { costTopic } from 'widgets/myPortfolioCapsules/topics/costs/costTopic';

export const rawCostTopic: Topic = {
    ...costTopic({
        costField: 'arrivalPSlip',
        valueField: 'arrivalPSlipWeightedByTradedValue',
        absValueField: 'arrivalPSlipAbsWeightedByTradedValue',
    }),
    type: TopicType.RawCost,
    description: 'Raw Cost',
    help: (
        <div>
            Raw Cost/Slippage is the difference between the arrival price of a
            trade and the price at which the trade is executed. This topic ranks
            symbols in your portfolio by taking the mean of the Raw
            Cost/Slippage weighted by traded dollar value using average price.
            You can sort by ascending or descending and configure the number of
            symbols you would like to display. You can rank Raw Cost/Slippage
            using absolute values for each symbol by ticking the preference in
            settings.
        </div>
    ),
    deriveShouldExcludeZeros: (config) => config.absoluteValues,
};
